import Washi from 'washi';

import DiscountCode from './discount-code';
import SeniorDiscount from './senior-discount';

import { stringIsPresent } from '../../utils/is-present';
import { t } from '../../utils/i18n';

export default {
  ui: {
    submitButton: '[data-submit-button]',
    seniorToggle: '[data-component="senior-discount"]',
  },

  initialize(options) {
    this.strings = {
      continue: t('common.continue'),
      applyDiscount: t('js.discount.apply_and_continue'),
      ...this.strings,
      ...(options && options.strings),
    };

    this.discountCode = Washi(DiscountCode, {
      el: '[data-component=discount-code]',
    }).get(0);

    this.seniorDiscount = Washi(SeniorDiscount, {}).get(0);

    // Listen for discount input changes
    if (this.discountCode) {
      this.discountCode.listen(this.handleDiscountCode, this);

      // Set initial state of submit button
      this.handleDiscountCode(this.discountCode.code());
    }

    if (this.seniorDiscount) {
      this.seniorDiscount.listen(this.handleDiscountCode, this);
    }
  },

  seniorToggleChecked() {
    let seniorToggle = this.ui.seniorToggle[0];

    if (seniorToggle) {
      return seniorToggle.checked;
    }

    return false;
  },

  handleDiscountCode(code) {
    if (stringIsPresent(code) && !this.seniorToggleChecked()) {
      this.ui.submitButton.forEach(
        (el) => (el.textContent = this.strings.applyDiscount),
      );
    } else {
      this.ui.submitButton.forEach(
        (el) => (el.textContent = this.strings.continue),
      );
    }
  },
};
